import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { trackClick } from "../lib/analytics";

const SiteContext = createContext(null);

export const SiteProvider = ({ children }) => {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [dark, setDark] = useState(() => localStorage.getItem("medlyn-theme") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("medlyn-theme", dark ? "dark" : "light");
  }, [dark]);

  const scrollToId = useCallback((id) => {
    const el = document.getElementById(id);
    if (!el) return false;
    el.scrollIntoView({ block: "start" });
    return true;
  }, []);

  const openBooking = useCallback(() => {
    trackClick("book_consultation_opened");
    setBookingOpen(true);
  }, []);
  const toggleDark = useCallback(() => setDark((d) => !d), []);

  return (
    <SiteContext.Provider value={{ bookingOpen, setBookingOpen, openBooking, scrollToId, dark, toggleDark }}>
      {children}
    </SiteContext.Provider>
  );
};

export const useSite = () => useContext(SiteContext);
